<div #positioner class="positioner" [class.landscape]="isScreenRotated">
  <!-- tulya -->
  @if (loader) {
<div [ngStyle]="{'cursor':cursor,'aspect-ratio':canvasAspect}" class="mainDivLoader" [class.landscape]="isScreenRotated" style="background-image: url('/assets/Wrapper/Mobile_wrapper.png');
   /* background-size: 104% auto; */
   background-size: contain;
   background-repeat: no-repeat;
   background-position: center;">
    <span [ngClass]="{
      'bi bi-android android': device.platform == 'Android',
      'bi bi-apple iOS': device.platform == 'iOS'
    }"></span>
      <label class="loadbar" [ngStyle]="{'top': getTopPosition()}">
        <span class="sr-only"></span>
        <progress class="progressBar"></progress>
      </label>
    </div>
  }
  @if (!loader) {
    <img [ngStyle]="{'aspect-ratio':canvasAspect}" class="mobile-wrapper" [class.landscape]="isScreenRotated"
      src="assets/Wrapper/Mobile_wrapper.png" (mousemove)="updateTooltipPosition($event)">
    }
    @if (showCoordinates) {
      <div class="permanent-tooltip" #tooltipElement>
        <span>x: {{abscissa}}</span>
        <span>y: {{ordinate}}</span>
      </div>
    }
    <!-- <img *ngIf="!loader" class="mobile-wrapper" src="assets/Wrapper/Mobile_wrapper.png"> -->
    <canvas [class.landscape]="isScreenRotated" [class.portrait]="!isScreenRotated" #canvas class="screen"></canvas>
    <!-- <canvas class="hacky-stretcher" width="1" height="1"></canvas> -->
  </div>
  @if (displayError) {
    <div class="screen-error">
      <div class="screen-error-message">
        <!-- <nothing-to-show message="{{ 'No device screen' | }}" icon="fa-eye-slash" ng-show="true"></nothing-to-show> -->
        <div class="well">
          <div class="screen-error-alert" ng-show="displayError === 'secure'">
            The current view is marked secure and cannot be viewed remotely.
          </div>
          <div class="screen-error-alert" ng-show="displayError === 'timeout'">
            Retrieving the device screen has timed out.
          </div>
        </div>
        <div class="well">
          <button ng-click="retryLoadingScreen()" style="text-align: center;" class="btn btn-primary btn-block">
            <i class="fa fa-refresh"></i>
            <span>Retry</span>
          </button>
        </div>
      </div>
    </div>
  }
  <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off"
    focus-element="$root.screenFocus" />


  @if (fullViewDevice) {
    <div class="fullViewDevice col-12 col-md-12">
      <app-full-view [device]="device" [control]="control" (fullViewExit)="handlefullView($event)"></app-full-view>
    </div>
  }

  <div class="toast-container" id="toastContainer"></div>